import React from "react";
import { ForgetPasswordContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import queryString from "query-string";
import { toast } from "react-toastify";
import { userService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Displays, Forms } from "components";

class ForgetPasswordContainer extends React.Component {
  state = {
    initialEmail: "",
  };

  componentDidMount() {
    const { email } = queryString.parse(this.props.router.location.search);
    if (email) {
      this.setState({ initialEmail: email });
    }
  }

  handleSignUp = () => {
    this.props.router.navigate(ROUTE_PATH.REGISTER);
  };

  handleSubmit = async (values) => {
    this.setState({ isBgLoading: true });
    let res = await userService.POST_FORGOT_PASSWORD({
      email: values.username,
    });
    if (res && res.status === 200) {
      this.setState({ isBgLoading: false });
      this.props.router.navigate(ROUTE_PATH.FORGET_PASSWORD_COMPLETE);
    } else {
      this.setState({ isBgLoading: false });
      toast.error(res?.data?.error?.message || "Something went wrong");
    }
  };

  render() {
    const { isBgLoading, initialEmail } = this.state;

    return (
      <ForgetPasswordContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <Forms.ForgetPasswordForm
          initialEmail={initialEmail}
          onSignUp={this.handleSignUp}
          onSubmit={this.handleSubmit}
        />
      </ForgetPasswordContainerStyled>
    );
  }
}

export default withRouter(ForgetPasswordContainer);
